"use client";

import { Button, ButtonProps } from "../ui/button";
import { RedirectType, useRouter, useSearchParams } from "next/navigation";
import { ArrowNext } from "@/assets/icons";
import { useLocale } from "next-intl";
import { redirect } from "@/i18n/navigation";
import { QueryParams } from "next-intl/navigation";
import { toForwardableQuery } from "@/utils/to-forwardable-query";

type BackButtonProps = {
  pathname?: string;
  externalHref?: string;
  // NOTE: if you don't provide query, it will preserve current query params
  query?: QueryParams;
} & Omit<ButtonProps, "onClick" | "icon">;

export const BackButton = ({
  pathname,
  externalHref,
  query,
  variant = "link",
  size = "link",
  ...buttonProps
}: BackButtonProps) => {
  const router = useRouter();
  const locale = useLocale();
  const searchParams = useSearchParams();

  return (
    <Button
      variant={variant}
      icon={
        variant === "link" ? (
          <ArrowNext className="align-center order-first rotate-180" />
        ) : undefined
      }
      onClick={() => {
        if (externalHref) {
          window.location.assign(externalHref);
          return;
        }

        if (pathname) {
          redirect(
            {
              href: {
                pathname,
                query: query ?? toForwardableQuery(searchParams),
              },
              locale,
            },
            RedirectType.replace,
          );
        } else {
          return router.back;
        }
      }}
      size={size}
      className="py-0"
      {...buttonProps}
    />
  );
};
